export interface STAddress {
    street?: string;
    streetAddress?: string;
    unit?: string;
    city?: string;
    state?: string;
    zip?: string;
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface ServiceAddress {
    id: number;
    name: string;
    text: string;
    data: STAddress;
}

export const formatAddress = (address: STAddress | AddressModel) => {
    const street =
        'streetAddress' in address ? (address.streetAddress ?? address.street) : address.street;
    const streetWithUnit = address.unit ? `${street} ${address.unit}` : street;
    return [streetWithUnit, address.city, address.state, address.zip].filter(i => !!i).join(', ');
};

export const createServiceAddress = (
    id: number,
    name: string,
    address: STAddress,
    text?: string
): ServiceAddress => ({
    id,
    name,
    data: address,
    text: text ?? formatAddress(address),
});

export class ServiceAddressStore {
    private idCounter = 1;
    private allAddresses: ServiceAddress[] = [];

    get addresses() {
        return [...this.allAddresses];
    }

    addAddress(name: string, address: undefined): undefined;
    addAddress(name: string, address: STAddress): ServiceAddress;
    addAddress(name: string, address?: STAddress): ServiceAddress | undefined {
        if (!address) {
            return undefined;
        }

        const text = formatAddress(address);
        const existed = this.allAddresses.find(add => add.text === text && add.name === name);

        if (existed) {
            return existed;
        }

        const add = createServiceAddress(this.idCounter++, name ?? '', address, text);

        this.allAddresses.push(add);

        return add;
    }

    get(id: number): ServiceAddress | undefined {
        return this.allAddresses.find(a => a.id === id);
    }
}
